import { render, staticRenderFns } from "./ItemsEdit.vue?vue&type=template&id=0f375b6a&"
import script from "./ItemsEdit.vue?vue&type=script&lang=js&"
export * from "./ItemsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports